// frontend/src/data/SponsorsData.js

const SponsorsData = [
    // ===== Featured (Top Row) =====
    {
        id: 1,
        name: "Fayetteville Heating and Air",
        tier: "Victory Lane Partner",
        logoUrl: "/sponsors/fayetteville-heating.webp",
        website: "https://www.fayettevilleheatingandair.com/",
    },
    {
        id: 2,
        name: "Eco Advantage Termite and Pest Solutions",
        tier: "Pole Position Partner",
        logoUrl: "/sponsors/eco-advantage.webp",
        website: "https://www.ecoadvantagenc.com/",
    },
    {
        id: 3,
        name: "Culbertson Electric",
        tier: "Green Flag Partner",
        logoUrl: "/sponsors/culbertson.webp",
        website: "",
    },
    {
        id: 4,
        name: "Simpson Race Products",
        tier: "Pre-Race Tech Partner",
        logoUrl: "/sponsors/simpson.webp",
        website: "https://www.simpsonraceproducts.com/",
    },

    // ===== Series Partners =====
    { id: 5, name: "Gen3 Performance Imaging", tier: "Series Partner", logoUrl: "/sponsors/gen3-performance.webp", website: "" },
    { id: 6, name: "Cashwell Home Services", tier: "Series Partner", logoUrl: "/sponsors/cashwell-homes.webp", website: "" },
    { id: 7, name: "Clear Cut Landscaping", tier: "Series Partner", logoUrl: "/sponsors/clearcut.webp", website: "https://www.clearcutlandscapeandexcavation.com/" },
    { id: 8, name: "Red Line Tire and Auto", tier: "Series Partner", logoUrl: "/sponsors/redline.webp", website: "https://goredline.com/" },
    { id: 9, name: "Brownies Towing", tier: "Series Partner", logoUrl: "/sponsors/brownies.webp", website: "" },
    { id: 10, name: "Fast Lane Towing", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 11, name: "Quality Towing", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 12, name: "Old South Apparel", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 13, name: "Wisler Designs", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 14, name: "Bubba’s 33", tier: "Series Partner", logoUrl: "/sponsors/bubbas.webp", website: "https://www.bubbas33.com/location/bubbas-33-fayettevillenc/detail?utm_source=facebook&utm_medium=social&utm_content=about" },
    { id: 15, name: "Five Star Entertainment", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 16, name: "Paradise Acres", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 17, name: "Raging Rooster Catering", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 18, name: "Sports Action TV", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 19, name: "Big T’s", tier: "Series Partner", logoUrl: "/sponsors/bigts.webp", website: "" },
    { id: 20, name: "Hollerin Haunts Hayride", tier: "Series Partner", logoUrl: "/sponsors/hollerin-haunts.webp", website: "https://hollerinhauntshayride.com/" },
    { id: 21, name: "VP Racing Fuels", tier: "Series Partner", logoUrl: "sponsors/vpracing.webp", website: "" },
    { id: 22, name: "Jim Lewis Designs", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 23, name: "Idol 34 Motorsports", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 24, name: "ABW Property Professionals", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 25, name: "Leviners Landscaping", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 26, name: "Express Employment Professionals", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 27, name: "Diamond Constructors", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 28, name: "Cuppa Yo", tier: "Series Partner", logoUrl: "", website: "" },
    { id: 28, name: "Premier Detailing", tier: "Series Partner", logoUrl: "/sponsors/premier.webp", website: "" },
    { id: 28, name: "Saam's Party Tents", tier: "Series Partner", logoUrl: "/sponsors/saams.webp", website: "" },
];

export default SponsorsData;